import React from 'react';
import './LoadingPopup.css';

const LoadingPopup = () => {
    return (
        <div className='loading-overlay'>
            <div className='loading-content'>
                <div className="animation-container">
                    <svg width="200" height="60" viewBox='0 0 200 60' className='path-svg'>
                        <circle cx="20" cy="30" r="6" className='point start-point'/>

                        <path d="M 20 30 L 180 30" className='dotted-path'/>

                        <circle cx="180" cy="30" r="6" className='point end-point'/>

                        <text x="0" y="0" className='travel-icon'>✈️</text>
                    </svg>
                </div>
                <p>Generating your plan</p>
                <span className='loading-subtext'>Searching for the best route...</span>
            </div>
        </div>
    );
};

export default LoadingPopup;
